import { a as __awaiter } from '../../../../tslib.es6-c563c1dd.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import moment from 'moment';
import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, Typography, Box, FormControlLabel, Switch, DialogActions, Button } from '@mui/material';
import { msToTime } from '../../../../utils/msToTime.js';
import { DebugFile } from './DebugFile.js';
import 'notistack';
import 'react-feather';
import '../../../../utils/clipboardCopy.js';

class Debugger$1 {
    constructor() {
        this.initial = () => __awaiter(this, void 0, void 0, function* () {
            return {
                web: false,
                magic: false,
                instrumentation: false,
            };
        });
        this.initialPath = () => __awaiter(this, void 0, void 0, function* () {
            return {
                web: null,
                magic: null,
            };
        });
        this.get = () => __awaiter(this, void 0, void 0, function* () {
            let debug = yield this.initial();
            const storedData = localStorage.getItem('debugger');
            if (storedData) {
                debug = JSON.parse(storedData);
            }
            return debug;
        });
        this.set = (debug) => __awaiter(this, void 0, void 0, function* () {
            localStorage.setItem('debugger', JSON.stringify(debug));
        });
        this.getStatus = () => __awaiter(this, void 0, void 0, function* () {
            const storedData = localStorage.getItem('debugger-status');
            if (storedData) {
                return storedData;
            }
            return false;
        });
        this.setStatus = (status) => __awaiter(this, void 0, void 0, function* () {
            localStorage.setItem('debugger-status', JSON.stringify(status));
        });
        this.getPath = () => __awaiter(this, void 0, void 0, function* () {
            let path = yield this.initialPath();
            const storedData = localStorage.getItem('debugger-path');
            if (storedData) {
                path = JSON.parse(storedData);
            }
            return path;
        });
        this.setPath = (path) => __awaiter(this, void 0, void 0, function* () {
            localStorage.setItem('debugger-path', JSON.stringify(path));
        });
    }
}
var StorageDebugger = new Debugger$1();

const PREFIX = 'Debugger';
const classes = {
    container: `${PREFIX}-container`,
    loader: `${PREFIX}-loader`,
    dialogActions: `${PREFIX}-dialogActions`,
};
const StyledDialog = styled(Dialog)(() => ({
    [`& .${classes.container}`]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    [`& .${classes.loader}`]: {
        marginLeft: '5px',
    },
    [`& .${classes.dialogActions}`]: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px 24px',
    },
}));
const useFetch = () => {
    const [value, setValue] = useState({});
    const [status, setStatus] = useState(false);
    const [path, setPath] = useState(false);
    useEffect(() => {
        const start = () => __awaiter(void 0, void 0, void 0, function* () {
            const storageStatus = yield StorageDebugger.getStatus();
            setValue(yield StorageDebugger.get());
            setStatus(storageStatus === 'false' || !storageStatus ? false : storageStatus);
            setPath(yield StorageDebugger.getPath());
        });
        start();
    }, []);
    return [value, setValue, status, setStatus, path, setPath];
};
const Debugger = ({ open, setOpen, logService, logAxios, logMonitorUrl, }) => {
    const [debugging, setDebugging, status, setStatus, path, setPath,] = useFetch();
    const [timer, setTimer] = useState('00:00:00');
    useEffect(() => {
        let intervalId;
        if (status && open) {
            intervalId = setInterval(() => {
                const diff = moment().diff(moment(status));
                setTimer(msToTime(diff));
            }, 1000);
        }
        else {
            clearInterval(intervalId);
            setTimer('00:00:00');
        }
        return () => clearInterval(intervalId);
    }, [status, open]);
    const handleClose = () => {
        setOpen(false);
    };
    const handleSet = (event) => {
        const { checked, name } = event.target;
        const value = Object.assign(Object.assign({}, debugging), { [name]: checked });
        setDebugging(value);
    };
    const handleMonitorClick = () => {
        window.open(logMonitorUrl, '_blank');
    };
    const enableDisable = () => __awaiter(void 0, void 0, void 0, function* () {
        const eventStatus = status
            ? false
            : moment().format('YYYY-MM-DD HH:mm:ss.000');
        if (eventStatus) {
            // ON
            let promiseWeb;
            let promiseMagic;
            if (debugging.web) {
                promiseWeb = logService.web(debugging.web);
            }
            if (debugging.magic) {
                promiseMagic = logService.magic(debugging.magic);
            }
            if (debugging.instrumentation) {
                logService.instrumentation(debugging.instrumentation);
            }
            Promise.all([promiseWeb, promiseMagic]).then(values => {
                const newPath = {
                    web: values[0] !== undefined ? values[0].file : null,
                    magic: values[1] !== undefined ? values[1].file : null,
                };
                setPath(newPath);
                StorageDebugger.setPath(newPath);
            });
            StorageDebugger.set(debugging);
        }
        else {
            // OFF
            const initial = yield StorageDebugger.initial();
            const initialPath = yield StorageDebugger.initialPath();
            logService.web(false);
            logService.magic(false);
            logService.instrumentation(false);
            setDebugging(initial);
            StorageDebugger.set(initial);
            setPath(initialPath);
            StorageDebugger.setPath(initialPath);
        }
        setStatus(eventStatus);
        StorageDebugger.setStatus(eventStatus);
    });
    return (jsxs(StyledDialog, Object.assign({ open: open, onClose: handleClose, "aria-labelledby": "responsive-dialog-title" }, { children: [jsx(DialogTitle, Object.assign({ id: "responsive-dialog-title" }, { children: "Depurador" })), jsx(DialogContent, { children: jsxs("div", Object.assign({ className: classes.container }, { children: [jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: "Ative os ambientes a serem analisados:" })), jsxs(Box, Object.assign({ mt: 1, className: classes.container }, { children: [jsx(FormControlLabel, { control: jsx(Switch, { checked: debugging.web, edge: "start", name: "web", onChange: handleSet }), label: "Web" }), jsx(FormControlLabel, { control: jsx(Switch, { checked: debugging.magic, edge: "start", name: "magic", onChange: handleSet }), label: "Magic" }), jsx(FormControlLabel, { control: jsx(Switch, { checked: debugging.instrumentation, edge: "start", name: "instrumentation", onChange: handleSet }), label: "Instrumenta\u00E7\u00E3o" })] })), (path.web || path.magic) && (jsxs(Box, Object.assign({ mt: 1 }, { children: [path.web && (jsx(DebugFile, { title: "Log Web", dateTime: status, filePath: path.web, logService: logService, logAxios: logAxios, type: "web" })), path.magic && (jsx(DebugFile, { title: "Log Magic", dateTime: status, filePath: path.magic, logService: logService, logAxios: logAxios, type: "magic" }))] })))] })) }), jsxs(DialogActions, Object.assign({ className: classes.dialogActions }, { children: [jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: timer })), jsx(Button, Object.assign({ color: "grey", onClick: handleMonitorClick }, { children: "MONITOR APM" })), jsx(Button, Object.assign({ onClick: enableDisable, variant: "contained", autoFocus: true }, { children: status ? 'Finalizar' : 'Iniciar' }))] }))] })));
};

export { Debugger };
